var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 27L0 9L4.5 0H25.5L30 9L15 27ZM11.4375 7.5H18.5625L16.3125 3H13.6875L11.4375 7.5ZM13.5 20.5125V10.5H5.175L13.5 20.5125ZM16.5 20.5125L24.825 10.5H16.5V20.5125ZM21.9 7.5H25.875L23.625 3H19.65L21.9 7.5ZM4.125 7.5H8.1L10.35 3H6.375L4.125 7.5Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon (2).d2065a51523711e54d19565256d7e4d2.svg";
export { ForwardRef as ReactComponent };